// Sistema de popups del sitio (bienvenida, Black Friday, etc.) — cada uno
// es un bloque independiente de sections/popups.liquid, cada uno con su
// propia clave de localStorage (data-storage-key), así que cerrar/ver uno
// no afecta a los demás.
//
// Solo se muestra UNO por carga de página, aunque haya varios elegibles al
// mismo tiempo: se recorren en el orden en que Liquid los renderizó (que es
// el orden de los bloques en el Customizer) y gana el primero que este
// navegador todavía no haya visto. Evita que se apilen dos modales a la vez
// (los <dialog> con showModal() no se llevan bien apilados).
(function () {
  var dialogs = Array.prototype.slice.call(document.querySelectorAll('[data-site-popup]'));
  if (!dialogs.length) return;

  function hasSeen(key) {
    try {
      return !!window.localStorage.getItem(key);
    } catch (e) {
      return false; // localStorage bloqueado — mejor esfuerzo, se muestra igual
    }
  }

  function markSeen(key) {
    try {
      window.localStorage.setItem(key, String(Date.now()));
    } catch (e) {
      // nada que hacer — en el peor caso vuelve a aparecer la próxima vez
    }
  }

  var candidate = null;
  for (var i = 0; i < dialogs.length; i++) {
    var key = dialogs[i].getAttribute('data-storage-key');
    if (!hasSeen(key)) {
      candidate = dialogs[i];
      break;
    }
  }
  if (!candidate) return;

  function close() {
    if (candidate.open) candidate.close();
  }

  var storageKey = candidate.getAttribute('data-storage-key');
  var delaySeconds = parseFloat(candidate.getAttribute('data-delay'));
  var delayMs = isNaN(delaySeconds) ? 5000 : delaySeconds * 1000;

  var timer = setTimeout(function () {
    if (typeof candidate.showModal === 'function') {
      candidate.showModal();
    } else {
      candidate.setAttribute('open', '');
    }
    markSeen(storageKey);
  }, delayMs);

  var closeBtn = candidate.querySelector('[data-site-popup-close]');
  if (closeBtn) closeBtn.addEventListener('click', close);

  // Click afuera de la tarjeta (sobre el backdrop) también cierra.
  candidate.addEventListener('click', function (event) {
    if (event.target === candidate) close();
  });

  var cta = candidate.querySelector('[data-site-popup-cta]');
  if (cta) cta.addEventListener('click', function () { markSeen(storageKey); });

  // Si navega a otra página antes de que se cumpla el delay, no queda un
  // timer colgado.
  window.addEventListener('beforeunload', function () {
    clearTimeout(timer);
  });
})();
